import React from "react";
import { Grid, RadioGroup } from "@mui/material";
import { Bundle } from "../../../../../generated/definitions/payment-ecommerce/Bundle";
import { PaymentPSPListGridItem } from "./PaymentPspListGridItem";

interface PSPGridProps {
  pspList: Array<Bundle>;
  onPspSelected: (psp: Bundle) => void;
  currentSelectedPsp?: Bundle;
  ariaLabelledBy?: string;
}

const getPspValue = (psp: Bundle, index: number) =>
  String(psp.idPsp ?? `pspItem-${index}`);

export const PaymentPSPListGrid = ({
  pspList,
  onPspSelected,
  currentSelectedPsp,
  ariaLabelledBy,
}: PSPGridProps) => {
  const selectedId = (() => {
    if (currentSelectedPsp == null) {
      return "";
    }
    if (currentSelectedPsp.idPsp != null) {
      return String(currentSelectedPsp.idPsp);
    }
    const idx = pspList.indexOf(currentSelectedPsp);
    return idx >= 0 ? getPspValue(currentSelectedPsp, idx) : "";
  })();

  return (
    <RadioGroup
      name="psp-selector"
      aria-labelledby={ariaLabelledBy}
      value={selectedId}
      onChange={(_, value) => {
        const found = pspList.find(
          (p, index) => getPspValue(p, index) === value
        );
        if (found) {
          onPspSelected(found);
        }
      }}
    >
      <Grid container>
        {pspList.map((pspItem, index) => (
          <PaymentPSPListGridItem
            key={pspItem.idPsp ?? `pspItem-${index}`}
            pspItem={pspItem}
            radioValue={getPspValue(pspItem, index)}
            isSelected={getPspValue(pspItem, index) === selectedId}
          />
        ))}
      </Grid>
    </RadioGroup>
  );
};
